import { SxProps, Theme } from "@mui/material";
import { titleStyle } from "../customerManagement/customerStepStyles";
import colors from "../../theme/Colours";

export const nameStyle: SxProps = {
  ...titleStyle,
  fontFamily: "Poppins",
  fontSize: {
    xs: "16px",
    sm: "24px",
  },
  mt: 0,
};

export const labelStyle = (isMobile: boolean, isSeller: boolean) => ({
  fontSize: isSeller ? "14px" : isMobile ? "10px" : "12px",
  fontWeight: isSeller ? 500 : 400,
  color: isSeller ? colors.customerTablelabel : undefined,
  "&.MuiTableCell-root.MuiTableCell-root": {
    padding: isSeller ? "12px 13px" : "8px 3px",
    width: isSeller ? "25%" : "26%",
  },
});

export const cellStyle = (
  field: string,
  isMobile: boolean,
  isSeller: boolean
) => ({
  fontSize:
    !isSeller && isMobile ? "10px" : field === "orderId" ? "12px" : "14px",
  color: isSeller ? colors.customerTablelabel : undefined,
  "&.MuiTableCell-root.MuiTableCell-root": {
    padding: isSeller
      ? field === "credit"
        ? "12px 13px 12px 48px"
        : "12px 13px"
      : "18px 5px",
    width: isSeller ? "25%" : "auto",
  },
});

export const getDataTableHeaderRowStyle = (isSeller: boolean) => ({
  backgroundColor: isSeller
    ? colors.customerTableHeaderBG
    : colors.countersBGColor,
  padding: isSeller ? "12px 0" : "8px 3px",
});

export const addNewButtonStyle: SxProps = {
  color: colors.primaryButtonOrange,
  borderColor: colors.primaryButtonOrange,
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: 600,
  borderRadius: "8px",
  height: "40px",
  width: "130px",
};
export const creditNoteButtonStyle: SxProps = {
  ...addNewButtonStyle,
  width: "172px",
};

export const grandTotalStyle: SxProps = {
  fontFamily: "Poppins",
  fontWeight: "600",
  fontSize: {
    xs: "14px",
    sm: "16px",
  },
  color: colors.primaryButtonOrange,
  whiteSpace: "nowrap",
};

export const grandTotalAmountStyle = (positive: boolean) =>
  ({
    ...grandTotalStyle,
    color: positive
      ? colors.ledgerGrandTotalPositive
      : colors.ledgerGrandTotalNegative,
  }) as SxProps;

export const grandTotalMobVer: SxProps = {
  backgroundColor: colors.background2,
  borderRadius: "15px",
  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  paddingX: "20px ",
  mt: "8px",
  mb: "20px",
};

export const paginationMobVer = (isMobile: boolean): SxProps => ({
  "& .MuiPaginationItem-root": {
    fontSize: isMobile ? "12px" : "14px",
  },
  "& .MuiPagination-ul": {
    flexWrap: "nowrap",
  },
});

export const customerPaginationBoxStyle = {
  border: `1px solid ${colors.ledgerCustomerPaginationBox}`,
  padding: "16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mt: "14px",
};

export const headingTextStyle = {
  fontFamily: "Poppins",

  color: colors.black,
  fontSize: "36px",
  fontWeight: 500,
};

export const ledgerHeaderRowStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  flexWrap: "wrap",
  mb: "55px",
};

export const ledgerCustomerHeaderRowStyle: SxProps = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: 1,
  mt: "20px",
  mb: "24px",
};

export const dateRangeSortWrapperStyle: SxProps = {
  display: "flex",
  justifyContent: { xs: "space-between", sm: "flex-end" },
  width: { xs: "100%", sm: "auto" },
  gap: { xs: 0, sm: "16px" },
};

export const customerDateRangeSortWrapperStyle: SxProps = {
  ...dateRangeSortWrapperStyle,
  mt: { xs: "10px", sm: 0 },
};

export const transactionSummaryTextStyle: SxProps = {
  fontSize: { xs: "20px", sm: "28px" },
  fontWeight: 600,
};

export const sellerLedgerBreadcrumbStyle: SxProps = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.5,
  color: colors.primaryButtonOrange,
  fontSize: "14px",
  fontWeight: 500,
  cursor: "pointer",
  mb: 1.5,
};

export const sellerLedgerTitleRowStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  gap: 2,
  flexWrap: "wrap",
};

export const sellerLedgerCustomerSelectorWrapStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 1,
  width: { xs: "100%", sm: "auto" },
};

export const sellerLedgerCustomerLabelStyle: SxProps = {
  fontSize: "14px",
  fontWeight: 500,
  color: colors.textGrey,
  whiteSpace: "nowrap",
};

export const sellerLedgerCustomerSelectStyle: SxProps = {
  width: { xs: "100%", sm: "320px" },
  height: "40px",
  backgroundColor: colors.background2,
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: colors.background2,
    "& fieldset": {
      borderColor: colors.searchInputBorder,
    },
    "&:hover fieldset": {
      borderColor: colors.searchInputBorder,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.searchInputBorder,
    },
  },
};

export const sellerLedgerTopControlsStyle: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 2,
  flexWrap: "wrap",
  mt: 1,
  mb: 2,
};

export const sellerLedgerLeftControlsStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  flexWrap: "wrap",
};

export const sellerLedgerRightControlsStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  flexWrap: "wrap",
};

export const sellerDownloadIconButtonStyle: SxProps<Theme> = {
  width: "40px",
  height: "40px",
  minWidth: "40px",
  borderRadius: "4px",
  border: `1px solid ${colors.searchInputBorder}`,
  backgroundColor: colors.background2,
  padding: 0,
  "&:hover": {
    backgroundColor: colors.buttonHoverWhite,
  },
};

export const sellerDownloadIconStyle: SxProps = {
  width: "18px",
  height: "18px",
  borderradius: "8px",
};

export const getCardContentStyle = (isSellerLedgerRoute: boolean): SxProps => ({
  padding: isSellerLedgerRoute
    ? "16px 20px 24px 20px"
    : { xs: "20px", sm: "92px 144px" },
  ...(isSellerLedgerRoute && {
    "&:last-child": {
      paddingBottom: "24px",
    },
  }),
});

export const getCardHeaderWrapperStyle = (
  isSeller: boolean
): SxProps<Theme> => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: ["flexStart", "center"],
  flexDirection: "row",
  mt: isSeller ? 0 : "10px",
  mb: isSeller ? 0 : "10px",
});

export const downloadLedgerButtonStyle: SxProps<Theme> = {
  height: "40px",
  borderRadius: "6px",
  borderColor: colors.primaryButtonOrange,
  color: colors.primaryButtonOrange,
  fontWeight: 500,
  fontSize: "14px",
  textTransform: "none",
  padding: "0 25px",
  width: "fit-content",
  "&:hover": {
    borderColor: colors.primaryButtonOrange,
    backgroundColor: colors.primaryButtonOrangeLight,
  },
};

export const sellerSearchFieldStyle: SxProps = {
  width: "200px",
  height: "40px",

  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${colors.searchInputBorder}`,
  },
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "4px",
    fontSize: "12px",
    fontFamily: "Poppins, sans-serif",
  },
  "& .MuiInputBase-input": {
    padding: "10px 14px 10px 0px",
  },
};

export const emptyBoxStyle: SxProps = {
  height: "45px",
};

export const creditBoxStyle: SxProps = {
  height: "45px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const textFieldStyle: SxProps = {
  input: {
    textAlign: "center",
    py: "12px",
  },
};
